import { render, staticRenderFns } from "./CsvEtiquetasList.vue?vue&type=template&id=c95177c6&scoped=true&"
import script from "./CsvEtiquetasList.vue?vue&type=script&lang=js&"
export * from "./CsvEtiquetasList.vue?vue&type=script&lang=js&"
import style0 from "./CsvEtiquetasList.vue?vue&type=style&index=0&id=c95177c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95177c6",
  null
  
)

export default component.exports